<template>
<div>
	<v-dialog
		v-model="dialog"
		persistent
		width="500"
	>
		<v-card>
			<v-card-title
				class="headline indigo lighten-1"
				primary-title
			>
				<span class="title-text">{{title}}</span>
			</v-card-title>
			<v-card-text>
				{{message}}
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn color="gray darken-1" flat @click="cancel">{{ $t('common.no') }}</v-btn>
				<v-btn color="blue darken-1" flat @click="accept">{{ $t('common.yes') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-tooltip top :disabled="tooltip.length === 0">
		<v-btn v-bind="btnProps"
			slot="activator"
			@click="dialog = true"
		>
			<slot @click="dialog = true">
			</slot>
		</v-btn>
		<span>{{tooltip}}</span>
	</v-tooltip>
</div>
</template>

<script>
export default {
	data() {
		return ({
			dialog: false
		})
	},
	props: {
		btnProps: Object,
		title: String,
		message: String,
		tooltip: {
			type: String,
			default: ''
		}
	},
	methods: {
		accept() {
			this.$emit('accept')
			this.closeModal()
		},
		cancel() {
			this.$emit('cancel')
			this.closeModal()
		},
		closeModal() {
			this.dialog = false
		}
	}
}
</script>

<style scoped>
.title-text {
	color: #fff;
}
</style>
